import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CancelRequestService } from 'src/app/core/api-services/common/cancel-request.service';
import { GetRequestStatusesService } from 'src/app/core/api-services/customer/get-request-statuses.service';
import { SearchMyRequestsService } from 'src/app/core/api-services/customer/search-my-requests.service';
import { EsCommonService } from 'src/app/core/api-services/shared/es-common.service';
import { UtilService } from 'src/app/core/utilities/util.service';
import { BaseComponent } from 'src/app/shared/base/BaseComponent';

@Component({
  selector: 'app-uaepass-login-error',
  templateUrl: './uaepass-login-error.component.html',
  styleUrls: ['./uaepass-login-error.component.scss']
})
export class UaepassLoginErrorComponent extends BaseComponent implements OnInit {

  constructor(
      translateService: TranslateService,
      private searchRequestService: SearchMyRequestsService,
      private router: Router,
      private route: ActivatedRoute,
      public utilService: UtilService,
      private cancelRequestService: CancelRequestService,
      private getRequestStatusesService: GetRequestStatusesService,
      private esCommonService: EsCommonService,
      private toastr: ToastrService
    ) {
      super(translateService);
  
      this.translateService.onLangChange.subscribe((langChangeEvent) => {});
    }

  ngOnInit(): void {
  }

}
